export const PKG_NAME = "@hpcc-js/dgrid";
export const PKG_VERSION = "2.30.2";
export const BUILD_VERSION = "2.102.4";
